import * as Yup from "yup";
import { OfficeSearchFormKey } from "./models";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { specialCharactersNotAllowedValidationForOptionalField } from "../../../helpers/constants/commonValidationSchemaUtils";

export const SearchMdmOfficeSchema = (commonValidationMessages: KeyValueMap) =>
  Yup.object().shape({
    [OfficeSearchFormKey.officeName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [OfficeSearchFormKey.officeType]: Yup.string().optional(),
    [OfficeSearchFormKey.parentOffice]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [OfficeSearchFormKey.marketId]: Yup.string().default(""),
    [OfficeSearchFormKey.state]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [OfficeSearchFormKey.city]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [OfficeSearchFormKey.status]: Yup.string().default(""),
    [OfficeSearchFormKey.officeNameFilter]: Yup.string().default(""),
    [OfficeSearchFormKey.parentOfficeFilter]: Yup.string().default(""),
    [OfficeSearchFormKey.cityFilter]: Yup.string().default(""),
    [OfficeSearchFormKey.stateFilter]: Yup.string().default(""),
    [OfficeSearchFormKey.countryId]: Yup.string().default(""),
  });
